import classnames from 'classnames';
import React from 'react';

import styles from './RichTextEditorMenu.module.scss';
import { Props } from './RichTextEditorMenu.types';

const RichTextEditorMenu = React.forwardRef<HTMLDivElement, Props>(
  ({ className, children, ...props }, ref) => (
    <div {...props} ref={ref} className={classnames(styles.menu, className)}>
      {children}
    </div>
  )
);

export default RichTextEditorMenu;
